import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export function TabNav({
  tabs,
  active,
  onChange,
}: {
  tabs: { key: string; label: string }[];
  active: string;
  onChange: (key: string) => void;
}): ReactNode {
  return (
    <div className="mb-6 border-b border-border">
      <nav className="-mb-px flex">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => onChange(tab.key)}
            className={cn(
              "mr-8 border-b-2 py-3 text-sm font-medium transition-colors",
              active === tab.key
                ? "border-accent text-foreground"
                : "border-transparent text-muted-foreground hover:border-border hover:text-foreground"
            )}
          >
            {tab.label}
          </button>
        ))}
      </nav>
    </div>
  );
}
